import { useEffect, useState } from "react";

import { Column } from "primereact/column";
import { TreeTable } from "primereact/treetable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { MediaTooltip } from "../../../../components/media-tooltip";
import { DefaultButton } from "../../../../components/copy-button/styles";
import { DisciplineObjectTooltip } from "../../../../components/discipline-object-tooltip";
import { TreeTableCard } from "./styled";

import { getMediaCategoryList } from "../../../../services/media.service";
import handleLongText from "../../../../utils/handleLongText/handleLongText";

import { FaFolderOpen } from "react-icons/fa";
import { MdInfoOutline } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { Checkbox } from "primereact/checkbox";
import { productPublishPlaceUpdate } from "../../../../services/manager.service";
import { ISelectedNode } from "../../products/products-manager";
import { CategoryIcon } from "../table-links/styled";
import { codeTemplate } from "../utils";
import { CheckAllProductTemplate } from "./components/check-all-template";

export interface INode {
	children?: INode[];
	data: any;
	key: string;
}

interface ITreeTableProductsList {
	nodes: INode[];
	treeFields?: any;
	handleTableSort: any;
	sortField: any;
	sortOrder: any;
	loading?: any;
	handleMaterialActive?: any;
	isManagerTable?: boolean;
	isRowSelect?: boolean;
	disciplines?: ISelectedNode[];
	items?: ISelectedNode[];
	perPageSelectedMaterial?: { [key: number]: number };
	setPerPageSelectedMaterial?: (val: { [key: number]: number }) => void;
	objects?: number[];
	customColumns?: any[];
	setDisciplines?: (val: ISelectedNode[]) => void;
	setItems?: (val: ISelectedNode[]) => void;
	setObjects?: (val: number[]) => void;
	onExpand?: (e: any) => void;
	handleUpdateList?: (
		resp: any,
		message: string,
		showMessage: boolean
	) => void;
	noReasonMaterial?: number;
	currentPage?: number;
	setNoReason?: (val: number) => void;
	selectedFullNode?: INode;
	actionSelected?: number;
	setActionSelected?: (val: number) => void;
	expandedKeys?: {};
	setExpandedKeys?: any;
	handleClearSlection?: () => void;
	handleChangeCheckAllType?: (value: any) => void;
	allSelected?: boolean;
}

export const TreeTableProductsList: React.FC<ITreeTableProductsList> = ({
	nodes,
	treeFields,
	handleTableSort,
	sortField,
	sortOrder,
	onExpand,
	handleUpdateList,
	loading,
	children,
	isRowSelect,
	disciplines = [],
	items = [],
	objects = [],
	perPageSelectedMaterial = {},
	setDisciplines,
	setItems,
	setObjects,
	setPerPageSelectedMaterial,
	setActionSelected,
	isManagerTable = false,
	noReasonMaterial = 0,
	currentPage = 0,
	customColumns,
	selectedFullNode,
	actionSelected = 0,
	expandedKeys,
	setExpandedKeys,
	handleClearSlection,
	handleChangeCheckAllType,
	allSelected,
}) => {
	const [categoryList, setCategoryList] = useState<any>([]);

	const [checkAll, setCheckAll] = useState<boolean>(false);
	const { t: translation } = useTranslation();

	const [localExpandedKeys, setLocalExpandedKeys] = useState({});

	useEffect(() => {
		getMediaCategoryList().then((data) => setCategoryList(data));
	}, []);

	useEffect(() => {
		if (allSelected === false) {
			setCheckAll(allSelected);
		}
	}, [allSelected]);

	useEffect(() => {
		if (!!selectedFullNode && setActionSelected) {
			switch (actionSelected) {
				case 0:
					break;
				case 1:
					checkMethod(false, selectedFullNode);
					setActionSelected(0);
					break;
				default:
					break;
			}
		}
	}, [actionSelected]);

	const handleTextIndicators = (node: any) => {
		let html = null;

		if (node.children && node.children.length > 0) {
			if (!node.data.is_complete) {
				html = (
					<>
						<li>
							{translation(
								"manager.indicators.hasIncompleteObject"
							)}
						</li>
					</>
				);
			}

			if (node.data.status === 2 && !node.data.is_published) {
				html = (
					<>
						{html}
						<li>
							{translation(
								"manager.indicators.hasUnpublishedMaterial"
							)}
						</li>
					</>
				);
			}

			if (node.data.status === 1 && node.data.is_published) {
				html = (
					<>
						{html}
						<li>
							{translation(
								"manager.indicators.hasPublishedMaterial"
							)}
						</li>
					</>
				);
			}
		} else {
			if (!node.data.is_complete) {
				if (node.data.type === "Media") {
					html = (
						<>
							<li>
								{translation(
									"manager.indicators.isIncompleteObject"
								)}
							</li>
						</>
					);
				} else {
					html = (
						<>
							<li>
								{translation(
									"manager.indicators.hasIncompleteObject"
								)}
							</li>
						</>
					);
				}
			} else {
				html = null;
			}
		}

		return html;
	};

	function nameTemplate(node: any) {
		let name = node.data.title;
		return (
			<>
				{name.length > 33 ? (
					<OverlayTrigger overlay={<Tooltip>{name}</Tooltip>}>
						<span className="item-title-span">{name}</span>
					</OverlayTrigger>
				) : (
					<span className="item-title-span">{name}</span>
				)}

				{node.data.type === "Discipline" ||
				node.data.type === "Item" ||
				node.data.type === "Theme" ? (
					<DisciplineObjectTooltip
						node={node.data}
						category={categoryList}
					>
						<DefaultButton
							style={{ float: "right", marginTop: "0.2em" }}
							type="button"
							data-testid="copybtn"
						>
							<FaFolderOpen
								style={{
									color: `${
										node.data.is_active
											? "#606060"
											: "#CCCCCC"
									}`,
								}}
							></FaFolderOpen>
						</DefaultButton>
					</DisciplineObjectTooltip>
				) : (
					<></>
				)}
				{/* {(node.data.type === 'Item' || node.data.type === 'theme') ? <FaFolderOpen style={{ float: 'right', marginTop: '0.5em' }}></FaFolderOpen> : <></>} */}
				{node.data.type === "Media" ? (
					<MediaTooltip node={node}>
						<DefaultButton
							style={{ float: "right", marginTop: "0.2em" }}
							type="button"
							data-testid="copybtn"
						>
							<CategoryIcon
								style={{
									color: "#606060",
								}}
								className={`material-icons-${node.data.category.category_icon}`}
							>
								{node.data.category.category_icon.split(" ")[1]}
							</CategoryIcon>
						</DefaultButton>
					</MediaTooltip>
				) : (
					<></>
				)}

				{!!handleTextIndicators(node) && isManagerTable && (
					<OverlayTrigger
						placement={"top"}
						overlay={
							<Tooltip>
								<ul className="list-indicators">
									{handleTextIndicators(node)}
								</ul>
							</Tooltip>
						}
					>
						<span
							style={{
								float: "right",
								marginTop: "0.2em",
								cursor: "pointer",
							}}
						>
							<MdInfoOutline
								size="20"
								className="mr-2"
								style={{ color: "#F39035" }}
							/>
						</span>
					</OverlayTrigger>
				)}
			</>
		);
	}

	function partnerTemplate(node: any) {
		return (
			<>
				{node.data.responsible && node.data.responsible.length >= 23 ? (
					<OverlayTrigger
						placement={"top"}
						overlay={
							<Tooltip id={`tooltip-materials`}>
								{node.data.responsible}
							</Tooltip>
						}
					>
						<span>{handleLongText(node.data.responsible, 23)}</span>
					</OverlayTrigger>
				) : (
					<span>{node.data.responsible}</span>
				)}
			</>
		);
	}

	const LocationTemplate: React.FC = (node: any) => {
		const [checked, setChecked] = useState<boolean>(node.data.is_location);
		const [isDisabled, setIsDisabled] = useState<boolean>(false);

		const handleCheckLocation = (e: any) => {
			let obj = {
				is_location: e.checked,
				material_id: node.data.id,
				material_type: node.data.type.toLowerCase(),
			};
			productPublishPlaceUpdate(obj).then((response: any) => {
				if (handleUpdateList) {
					handleUpdateList(response, "", false);
				}
			});

			setChecked(e.checked);
		};

		useEffect(() => {
			if (!node.data.is_active || node.data.is_published) {
				setIsDisabled(true);
			} else {
				setIsDisabled(false);
			}
		}, []);

		return (
			<Checkbox
				tooltip={
					!checked
						? "Selecionar material"
						: node.data.is_published
						? "Material publicado"
						: "Material apto para publicação na locação"
				}
				tooltipOptions={{ position: "top" }}
				disabled={isDisabled}
				checked={checked}
				onChange={(e) => handleCheckLocation(e)}
			/>
		);
	};

	const StoreTemplate: React.FC = (node: any) => {
		const [checked, setChecked] = useState<boolean>(node.data.is_store);
		const [isDisabled, setIsDisabled] = useState<boolean>(false);

		const handleCheckStore = (e: any) => {
			let obj = {
				is_store: e.checked,
				material_id: node.data.id,
				material_type: node.data.type.toLowerCase(),
			};
			productPublishPlaceUpdate(obj).then((response: any) => {
				if (handleUpdateList) {
					handleUpdateList(response, "", false);
				}
			});
			setChecked(e.checked);
		};

		useEffect(() => {
			if (!node.data.is_active || node.data.is_published_store) {
				setIsDisabled(true);
			} else {
				setIsDisabled(false);
			}
		}, []);

		return (
			<Checkbox
				tooltip={
					!checked
						? "Selecionar material"
						: node.data.is_published_store
						? "Material publicado"
						: "Material apto para publicação na loja"
				}
				tooltipOptions={{ position: "top" }}
				disabled={isDisabled}
				checked={checked}
				onChange={(e) => handleCheckStore(e)}
			/>
		);
	};

	function rowClassName(node: any) {
		if ("is_active" in node.data) {
			if (!isManagerTable) {
				return {
					"p-inactivate": !node.data.is_active,
					"p-discipline": node.data.type === "Discipline",
					"p-theme": node.data.type === "Theme",
					"p-item": node.data.type === "Item",
					"p-media": node.data.type === "Media",
				};
			} else {
				return {
					"p-inactivate-manager": !node.data.is_active,
					"p-manager-table": true,
				};
			}
		} else {
			return {
				"p-discipline": node.data.type === "Discipline",
				"p-theme": node.data.type === "Theme",
				"p-item": node.data.type === "Item",
				"p-media": node.data.type === "Media",
			};
		}
	}

	const checkAllMethod = (
		insideCheck: boolean,
		_nodes: INode[],
		clearSelection?: boolean
	) => {
		if (clearSelection) {
			if (handleClearSlection) {
				handleClearSlection();
				disciplines = [];
				items = [];
				objects = [];
			}
		}

		if (
			setDisciplines &&
			disciplines &&
			setItems &&
			items &&
			setObjects &&
			objects
		) {
			let reasonableDisciplines: ISelectedNode[] = [];
			let reasonableItems: ISelectedNode[] = [];
			let reasonableMedias: number[] = [];

			let onPageSelected = perPageSelectedMaterial;

			if (isNaN(onPageSelected[currentPage])) {
				onPageSelected[currentPage] = 0;
			}

			if (insideCheck) {
				_nodes.forEach((node: INode) => {
					switch (node.data.type) {
						case "Discipline":
							if (
								// !node.data.reason &&
								!disciplines.some((i) => i.id === node.data.id)
							) {
								reasonableDisciplines.push({
									id: node.data.id,
									children_selected: true,
								});
								onPageSelected[currentPage] += 1;
							}

							if (node.children?.length) {
								node.children.forEach((item: INode) => {
									if (
										// !item.data.reason &&
										!items.some(
											(i) => i.id === item.data.id
										)
									) {
										reasonableItems.push({
											id: item.data.id,
											children_selected: true,
										});
										onPageSelected[currentPage] += 1;
									}

									if (item.children?.length) {
										item.children.forEach((media) => {
											if (
												// !media.data.reason &&
												!objects.includes(media.data.id)
											) {
												reasonableMedias.push(
													media.data.id
												);
												onPageSelected[
													currentPage
												] += 1;
											}
										});
									}
								});
							}

							break;
						case "Item":
						case "Theme":
							if (
								// !node.data.reason &&
								!items.some((i) => i.id === node.data.id)
							) {
								reasonableItems.push({
									id: node.data.id,
									children_selected: true,
								});
								onPageSelected[currentPage] += 1;
							}

							if (node.children?.length) {
								node.children.forEach((media: INode) => {
									if (
										// !media.data.reason &&
										!objects.includes(media.data.id)
									) {
										reasonableMedias.push(media.data.id);
										onPageSelected[currentPage] += 1;
									}
								});
							}

							break;
						case "Media":
							if (
								// !node.data.reason &&
								!objects.includes(node.data.id)
							) {
								reasonableMedias.push(node.data.id);
								onPageSelected[currentPage] += 1;
							}
							break;
						default:
							break;
					}
				});
				setDisciplines([...disciplines, ...reasonableDisciplines]);
				setItems([...items, ...reasonableItems]);
				setObjects([...objects, ...reasonableMedias]);
			} else {
				reasonableDisciplines = disciplines;
				reasonableItems = items;
				reasonableMedias = objects;

				//Deselect all
				_nodes.forEach((node: INode) => {
					switch (node.data.type) {
						case "Discipline":
							if (
								// !node.data.reason &&
								disciplines.some((i) => i.id === node.data.id)
							) {
								let i = reasonableDisciplines.findIndex(
									(i) => i.id === node.data.id
								);
								reasonableDisciplines.splice(i, 1);
								onPageSelected[currentPage] -= 1;

								if (node.children?.length) {
									node.children.forEach((item: any) => {
										if (
											!item.data.reason &&
											items.some(
												(i) => i.id === item.data.id
											)
										) {
											let i = reasonableItems.findIndex(
												(i) => i.id === item.data.id
											);
											reasonableItems.splice(i, 1);
											onPageSelected[currentPage] -= 1;

											if (item.children) {
												item.children.forEach(
													(media: any) => {
														if (
															!media.data
																.reason &&
															objects.includes(
																media.data.id
															)
														) {
															let i =
																reasonableMedias.indexOf(
																	media.data
																		.id
																);
															reasonableMedias.splice(
																i,
																1
															);
															onPageSelected[
																currentPage
															] -= 1;
														}
													}
												);
											}
										}
									});
								}
							}
							break;
						case "Item":
						case "Theme":
							if (
								!node.data.reason &&
								items.some((i) => i.id === node.data.id)
							) {
								let i = reasonableItems.findIndex(
									(i) => i.id === node.data.id
								);
								reasonableItems.splice(i, 1);
								onPageSelected[currentPage] -= 1;

								if (node.children?.length) {
									node.children.forEach((media: INode) => {
										if (
											!media.data.reason &&
											objects.includes(media.data.id)
										) {
											let i = reasonableMedias.indexOf(
												media.data.id
											);
											reasonableMedias.splice(i, 1);
											onPageSelected[currentPage] -= 1;
										}
									});
								}
							}
							break;
						case "Media":
							if (
								!node.data.reason &&
								objects.includes(node.data.id)
							) {
								let i = reasonableMedias.indexOf(node.data.id);
								reasonableMedias.splice(i, 1);
								onPageSelected[currentPage] -= 1;
							}
							break;
						default:
							break;
					}
				});

				setDisciplines([...reasonableDisciplines]);
				setItems([...reasonableItems]);
				setObjects([...reasonableMedias]);
			}

			if (setPerPageSelectedMaterial) {
				setPerPageSelectedMaterial(onPageSelected);
			}
		}

		setCheckAll(insideCheck);
	};

	const checkMethod = (insideCheck: boolean, node: INode) => {
		if (
			setDisciplines &&
			disciplines &&
			setItems &&
			items &&
			setObjects &&
			objects
		) {
			let onPageSelected = perPageSelectedMaterial;

			if (isNaN(onPageSelected[currentPage])) {
				onPageSelected[currentPage] = 0;
			}

			if (insideCheck) {
				switch (node.data.type) {
					case "Discipline":
						setDisciplines([
							...disciplines,
							{ ...node.data, children_selected: true },
						]);
						console.log(disciplines);
						onPageSelected[currentPage] += 1;

						// Selecting node's children
						let i: ISelectedNode[] = [];
						let h: number[] = [];
						if (node.children?.length) {
							node.children.forEach((item: any) => {
								if (!item.data.reason) {
									i.push({
										id: item.data.id,
										children_selected: true,
									});
									onPageSelected[currentPage] += 1;

									if (item.children) {
										item.children.forEach((media: any) => {
											if (!media.data.reason) {
												onPageSelected[
													currentPage
												] += 1;
												h.push(media.data.id);
											}
										});
									}
								}
							});
							setItems([...items, ...i]);
							setObjects([...objects, ...h]);
						}
						break;
					case "Item":
					case "Theme":
						setItems([
							...items,
							{ id: node.data.id, children_selected: true },
						]);
						onPageSelected[currentPage] += 1;

						// Selecting node's children
						let k: number[] = [];
						if (node.children?.length) {
							node.children.forEach((media: any) => {
								if (!media.data.reason) {
									onPageSelected[currentPage] += 1;
									k.push(media.data.id);
								}
							});
							setObjects([...objects, ...k]);
						}
						break;
					case "Media":
						setObjects([...objects, node.data.id]);
						onPageSelected[currentPage] += 1;
						break;
					default:
						break;
				}
			} else {
				switch (node.data.type) {
					case "Discipline":
						if (disciplines.some((i) => i.id === node.data.id)) {
							let i = disciplines.findIndex(
								(i) => i.id === node.data.id
							);
							disciplines.splice(i, 1);
							setDisciplines([...disciplines]);
							onPageSelected[currentPage] -= 1;

							// Deselecting node's children
							let children_item: ISelectedNode[] = items;
							let media_list: number[] = objects;

							if (node.children?.length) {
								node.children.forEach((item: any) => {
									if (!item.data.reason) {
										let i = children_item.findIndex(
											(i) => i.id === item.data.id
										);
										children_item.splice(i, 1);
										onPageSelected[currentPage] -= 1;

										if (item.children) {
											item.children.forEach(
												(media: any) => {
													if (!media.data.reason) {
														let i =
															media_list.indexOf(
																item.data.id
															);
														media_list.splice(i, 1);
														onPageSelected[
															currentPage
														] -= 1;
													}
												}
											);
										}
									}
								});
								setItems([...children_item]);
								setObjects([...media_list]);
							}
						}

						break;
					case "Theme":
					case "Item":
						if (items.some((i) => i.id === node.data.id)) {
							let j = items.findIndex(
								(i) => i.id === node.data.id
							);
							items.splice(j, 1);
							setItems([...items]);
							onPageSelected[currentPage] -= 1;

							// Deselecting node's children
							let item_children: number[] = objects;

							if (node.children?.length) {
								node.children.forEach((media: any) => {
									if (!media.data.reason) {
										let i = item_children.indexOf(
											media.data.id
										);
										item_children.splice(i, 1);
										onPageSelected[currentPage] -= 1;
									}
								});
								setObjects([...item_children]);
							}
						}

						break;
					case "Media":
						if (objects.includes(node.data.id)) {
							let k = objects.indexOf(node.data.id);
							objects.splice(k, 1);
							setObjects([...objects]);
							onPageSelected[currentPage] -= 1;
						}

						break;
					default:
						break;
				}
			}

			if (setPerPageSelectedMaterial) {
				setPerPageSelectedMaterial(onPageSelected);
			}
		}
	};

	const CheckTemplate: React.FC = (node: any) => {
		const [checked, setChecked] = useState<boolean>(false);

		useEffect(() => {
			if (disciplines && items && objects) {
				switch (node.data.type) {
					case "Discipline":
						setChecked(
							disciplines.some((i) => i.id === node.data.id)
						);
						break;
					case "Item":
					case "Theme":
						setChecked(items.some((i) => i.id === node.data.id));
						break;
					case "Media":
						setChecked(objects.includes(node.data.id));
						break;
					default:
						break;
				}
			}
		}, [node.data, disciplines, items, objects]);

		const checkFunc = (insideCheck: boolean) => {
			setChecked(insideCheck);
			checkMethod(insideCheck, node);
		};

		return (
			<>
				<Checkbox
					tooltip={!node.data.reason ? "Selecionar material" : ""}
					tooltipOptions={{ position: "top" }}
					disabled={false}
					checked={checked}
					onChange={(e) => {
						checkFunc(e.checked);
					}}
				/>
			</>
		);
	};

	const CheckAllTemplate: React.FC = () => {
		// useEffect(() => {
		// 	// ver se o número de materiais que podem ser selecionados nesta página estão selecionados
		// 	if (
		// 		perPageSelectedMaterial[currentPage] === noReasonMaterial &&
		// 		!!(noReasonMaterial - 1)
		// 	) {
		// 		setCheckAll(true);
		// 	} else {
		// 		setCheckAll(false);
		// 	}
		// }, [
		// 	nodes,
		// 	perPageSelectedMaterial,
		// 	noReasonMaterial,
		// 	currentPage,
		// 	disciplines,
		// 	items,
		// 	objects,
		// 	selectedFullNode,
		// ]); // Must have filter change dependency

		return (
			<>
				<CheckAllProductTemplate
					checkAll={checkAll}
					nodes={nodes}
					checkAllMethod={checkAllMethod}
					handleChangeCheckAllType={(value: any) =>
						handleChangeCheckAllType
							? handleChangeCheckAllType(value)
							: {}
					}
				></CheckAllProductTemplate>
				{/* <Checkbox
					tooltip={
						checkAll
							? "Limpar seleção nesta página"
							: "Selecionar todos nesta página"
					}
					tooltipOptions={{ position: "top" }}
					checked={checkAll}
					onChange={(e) => checkAllMethod(e.checked, nodes)}
				/> */}
			</>
		);
	};

	const generateKey = (pre: any) => {
		return `${pre}_${new Date().getTime()}`;
	};

	nodes.forEach((node: any, index: number) => {
		nodes[index] = {
			key: generateKey(node.data.id.toString()),
			...node,
		};
	});

	return (
		<div>
			<TreeTableCard>
				<TreeTable
					lazy
					value={nodes}
					rowClassName={rowClassName}
					sortField={sortField}
					sortOrder={sortOrder}
					onSort={(e) => handleTableSort(e)}
					loading={loading}
					onExpand={onExpand}
					expandedKeys={
						expandedKeys ? expandedKeys : localExpandedKeys
					}
					onToggle={(e) => {
						expandedKeys
							? setExpandedKeys(e.value)
							: setLocalExpandedKeys(e.value);
					}}
					resizableColumns showGridlines scrollable columnResizeMode="expand"
				>
					{isRowSelect && (
						<Column
							field="check"
							className="sm-actions"
							header={CheckAllTemplate({})}
							style={{
								textAlign: "center",
								width: "4%",
								padding: "0px",
							}}
							body={(node) => CheckTemplate(node)}
						></Column>
					)}

					{!!treeFields?.length &&
						treeFields?.map((col: any, index: any) => {
							if (customColumns) {
								if (col.field === "title") {
									return (
										<Column
											expander
											key={index}
											body={nameTemplate}
											field={col.field}
											header={col.header}
											style={col.style}
											{...col}
										/>
									);
								} else if (col.partnerTemplate) {
									return (
										<Column
											key={col.field}
											body={partnerTemplate}
											field={col.field}
											header={col.header}
											style={col.style}
											{...col}
										/>
									);
								} else if (col.locationTemplate) {
									return (
										<Column
											key={index}
											body={(node) =>
												LocationTemplate(node)
											}
											field={col.field}
											header={col.header}
											style={col.style}
											{...col}
										/>
									);
								} else if (col.storeTemplate) {
									return (
										<Column
											key={index}
											body={(node) => StoreTemplate(node)}
											field={col.field}
											header={col.header}
											style={col.style}
											{...col}
										/>
									);
								}

								if (
									customColumns.filter(
										(column) => column.field === col.field
									).length !== 0
								) {
									return (
										<Column
											key={index}
											field={col.field}
											header={col.header}
											style={col.style}
											{...col}
										/>
									);
								}
							} else {
								if (col.nameTemplate) {
									return (
										<Column
											expander
											key={index}
											body={nameTemplate}
											field={col.field}
											header={col.header}
											style={col.style}
											{...col}
										/>
									);
								} else if (col.partnerTemplate) {
									return (
										<Column
											key={col.field}
											body={partnerTemplate}
											field={col.field}
											header={col.header}
											style={col.style}
											{...col}
										/>
									);
								} else if (col.locationTemplate) {
									return (
										<Column
											key={index}
											body={(node) =>
												LocationTemplate(node)
											}
											field={col.field}
											header={col.header}
											style={col.style}
											{...col}
										/>
									);
								} else if (col.storeTemplate) {
									return (
										<Column
											key={index}
											body={(node) => StoreTemplate(node)}
											field={col.field}
											header={col.header}
											style={col.style}
											{...col}
										/>
									);
								} else if (col.codeTemplate) {
									return (
										<Column
											key={index}
											body={codeTemplate}
											field={col.field}
											header={col.header}
											style={col.style}
											{...col}
										/>
									);
								} else {
									return (
										<Column
											key={index}
											field={col.field}
											header={col.header}
											style={col.style}
											{...col}
										/>
									);
								}
							}
						})}
					{children}
				</TreeTable>
			</TreeTableCard>
		</div>
	);
};
